import React, { useState, useRef, useEffect } from 'react';
import Navigation from '../components/Navigation';
import { getMusicFiles } from '../utils/musicManager';
import './AlbumPreview.css';

const AlbumPreview = () => {
  const [currentTrack, setCurrentTrack] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [tracks, setTracks] = useState([]);
  const audioRef = useRef(null);

  // Load music files on component mount
  useEffect(() => {
    const musicFiles = getMusicFiles();
    let loadedTracks = [];

    if (musicFiles.length > 0) {
      // Map available music files to tracks
      loadedTracks = musicFiles.map((file, index) => ({
        id: index + 1,
        title: file.name,
        artist: "Tahir Palali",
        duration: "0:00", // Will be updated when file loads
        file: file.path
      }));
    } else {
      // Default track data from the screenshot
      loadedTracks = [
        { id: 1, title: "Hakk Mimarim", artist: "Tahir Palali, Erkan Ogur", duration: "0:48", file: null },
        { id: 2, title: "Rahm Eyle Halime", artist: "Tahir Palali", duration: "0:43", file: null },
        { id: 3, title: "Pervaz", artist: "Tahir Palali", duration: "0:42", file: null },
        { id: 4, title: "Hublarin Sahi", artist: "Tahir Palali", duration: "0:38", file: null },
      ];
    }

    setTracks(loadedTracks);
  }, []);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTrackClick = (index) => {
    setCurrentTrack(index);
    setIsPlaying(false);
  };

  return (
    <div className="album-preview-page">
      <Navigation />
      
      <div className="album-preview-content">
        <h1 className="album-title">TAHIR PALALI - O</h1>
        
        <div className="album-player">
          <div className="album-artwork-section">
            <div className="album-artwork">
              <img 
                src={require('../assets/images/O+Kapak_yazisiz.jpg')} 
                alt="Album Artwork" 
                className="artwork-image"
              />
            </div>
            <div className="album-actions">
              <a 
                href="https://open.spotify.com/album/7bttEnfJyOQmCqMMlREEAP" 
                target="_blank" 
                rel="noopener noreferrer"
                className="spotify-btn"
              >
                <svg className="spotify-icon" viewBox="0 0 24 24" width="20" height="20">
                  <path fill="currentColor" d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
                </svg>
                LISTEN ON SPOTIFY
              </a>
              <a 
                href={require('../assets/booklet.pdf')} 
                target="_blank" 
                rel="noopener noreferrer"
                className="booklet-btn"
              >
                VIEW BOOKLET
              </a>
            </div>
          </div>
          
          <div className="spotify-embed-section">
            <div className="spotify-embed">
              <iframe 
                src="https://open.spotify.com/embed/album/7bttEnfJyOQmCqMMlREEAP?utm_source=generator&theme=0" 
                width="100%" 
                height="352" 
                frameBorder="0" 
                allowfullscreen="" 
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                loading="lazy"
                title="Spotify Album Player"
              />
            </div>
          </div>
        </div>
        
      </div>
      
      <audio 
        ref={audioRef}
        src={tracks[currentTrack]?.file}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
};

export default AlbumPreview;